import { useCallback, useContext, useState } from "react";
import PopBottomSheetContext from "./context/PopBottomSheetContext";
import { PopBottomSheetContextType } from "./context/PopBottomSheetContext";
import PopBottomSheetContainer from "./container";

export interface PopBottomSheetHandle {
  show: (children: React.ReactNode) => void;
}

export type PopBottomSheetData = {
  title: string;
  children: React.ReactNode;
}

interface PopBottomSheetProps {
  children    : React.ReactNode;
}

export const PopBottomSheetProvider = ({
  children
} : PopBottomSheetProps) => {

  const [popBottomSheetData, SetPopBottomSheetData] = useState<PopBottomSheetData | undefined>(undefined);

  const showPopBottomSheet = useCallback((props:PopBottomSheetData) => {
    SetPopBottomSheetData(props);
  }, [popBottomSheetData]);

  const hidePopBottomSheet = useCallback(() => {
    SetPopBottomSheetData(undefined);
  }, [popBottomSheetData]);
  
  return (
    <PopBottomSheetContext.Provider
      value={{
        showPopBottomSheet
      }}
      >
      {children}
      <PopBottomSheetContainer
        onHide    = {hidePopBottomSheet}
        data      = {popBottomSheetData}
      />
    </PopBottomSheetContext.Provider>
  );
}

/**
 * Use PopBottomSheet hook.
 * @returns 
 */
const usePopBottomSheet = () => useContext(PopBottomSheetContext) as PopBottomSheetContextType;

const PopBottomSheetManager = {
  usePopBottomSheet: usePopBottomSheet
};

export { usePopBottomSheet };
export default PopBottomSheetManager;
